/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  AppContainer,
  GlobalStyle,
  useBlurAndAbove,
  Settings,
  ProvablyFair,
  History,
  GameRules,
  // Rules,
  BetReply,
  Notification,
  Loading,
  Error,
} from '@orbital/games-frontend-library'
import { getSettings, setAudio } from '../settings/useSettings'

import Game from './Game'

import { colors } from '../lib/colors'

import CustomReply from '../components/betReply/CustomReply'
import CustomRules from 'components/gameRules/CustomRules'

import { Holdem_Props } from './interfaces'
import { useCustomLoader } from './Loader'
import { handleBackgroundSFX } from './helpers/playBackground'
// import useSound from 'use-sound'
// import BackgroundSFX from '../lib/assets/audio/backgroundSFX.mp3'

export default function Holdem({
  gameInfo,
  history,
  betReply,
  seeds,
  stateRound,
  newSeedRequest,
  seedRequest,
  handleDeal,
  handleRaise,
  handleFold,
  errorText,
  stakesForSocket,
  requestBetReply,
  isError,
  notification,
  notificationfadeOut,
  handleNotification,
}: // audio,
// handleSettingsAudio,
Holdem_Props) {
  const { precision, user_id } = gameInfo
  const [blur, unBlur, settingsUnblur, above, handleAbove] = useBlurAndAbove()
  const audio = getSettings().audio
  const [showLoader, duration] = useCustomLoader(handleAbove, gameInfo.user_id)

  const [roundId, setRoundId] = useState<string>('')

  // droebit
  // const SFXS = useGlobalAudio(audio.volume, audio.sound)

  const handleAudio = (a: any) => setAudio(a)

  handleBackgroundSFX(audio, errorText, showLoader)

  const verifierFunc = () => {
    window.open('https://codepen.io/orbitalgaming/pen/ZEPOdpb', '_blank')
  }

  return (
    <AppContainer color={colors.primary}>
      <GlobalStyle />
      <Game
        blur={blur}
        gameInfo={gameInfo}
        colors={colors}
        handleAbove={handleAbove}
        stateRound={stateRound}
        handleNotification={handleNotification}
        handleDeal={handleDeal}
        handleRaise={handleRaise}
        handleFold={handleFold}
        audio={audio}
        stakesForSocket={stakesForSocket}
        showLoader={showLoader}
        isError={isError}
      />
      {above === 'settings' && (
        <Settings
          clickable={true}
          unBlur={settingsUnblur}
          colors={{
            ...colors,
            tertiary: colors.primary,
            primaryLight: colors.primaryDark,
          }}
          handleAbove={handleAbove}
          handleAudio={handleAudio}
          audio={audio}
        />
      )}
      {above === 'Provably Fair' && (
        <ProvablyFair
          colors={{ ...colors }}
          handleAbove={handleAbove}
          seeds={seeds}
          seedRequest={seedRequest}
          newSeedRequest={newSeedRequest}
          handleNotification={handleNotification}
          audio={audio}
          roundIsOn={stateRound.state === 1}
          verifierFunc={verifierFunc}
        />
      )}
      {above === 'Game Rules' && (
        <GameRules
          colors={{ ...colors, secondaryBackground: colors.tetriaryBackground }}
          handleAbove={handleAbove}
          audio={audio}
        >
          <CustomRules
            coefs={gameInfo.game_settings}
            minBet={parseFloat(gameInfo.minBet)}
            maxBet={parseFloat(gameInfo.maxBet)}
            currency={gameInfo.currency}
          />
        </GameRules>
      )}
      {above === 'History' && (
        <History
          clickable={true}
          unBlur={unBlur}
          handleAbove={handleAbove}
          history={history}
          audio={audio}
          toFix={precision}
          user_id={user_id}
          requestBetReply={requestBetReply}
          colors={{ ...colors, secondaryBackground: colors.tetriaryBackground }}
          handleNotification={handleNotification}
          setRoundId={setRoundId}
          betAmount={true}
        />
      )}
      {above === 'Bet Reply' && (
        <BetReply
          betReplyResponse={betReply}
          handleNotification={handleNotification}
          roundId={roundId}
          audio={audio}
          colors={{
            ...colors,
            closeStrokeColor: colors.primary,
            tertiaryDark: colors.primary,
          }}
          handleAbove={handleAbove}
          toFix={precision}
          betInfo={true}
          size={'18px'}
          headerpadding={'0 30px'}
        >
          <CustomReply betReplyResponse={betReply} precision={precision} />
        </BetReply>
      )}
      {showLoader && <Loading duration={duration} />}
      {notification && (
        <Notification
          colors={{ ...colors, tertiary: colors.primary }}
          fadeOut={notificationfadeOut}
          handleNotification={handleNotification}
          text={notification}
          unBlur={unBlur}
          audio={audio}
        />
      )}
      {!!errorText && <Error text={errorText} unBlur={false} audio={audio} />}
    </AppContainer>
  )
}
